import { SxProps, TextField, Theme, useTheme } from '@mui/material';
import React from 'react';

interface CustomTextFieldProps {
  id: string;
  label: string;
  value: string | number;
  onFieldChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  required?: boolean;
  customStyle?: SxProps<Theme>;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  onBlur?: () => void;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  id,
  label,
  value,
  onFieldChange,
  customStyle,
  required = false,
  error = false,
  disabled = false,
  helperText = '',
  onBlur,
}) => {
  const theme = useTheme();

  const inputStyle = {
    ...{
      '& .MuiInputLabel-root.Mui-focused': {
        color: theme.palette.primary.main,
      },
      '& .MuiInputBase-root': {
        color: '#162936',
        fontSize: '1rem',
        fontWeight: 500,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#737F86',
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
      },
    },
    ...customStyle,
  };

  return (
    <TextField
      id={id}
      {...(helperText ? { helperText } : {})}
      {...(onBlur ? { onBlur } : {})}
      required={required}
      label={label}
      value={value}
      onChange={onFieldChange}
      disabled={disabled}
      error={error}
      InputLabelProps={{
        shrink: !!value,
      }}
      sx={{
        ...inputStyle,
        '& .MuiFormHelperText-root': {
          margin: 0,
          padding: '0.25rem 0',
        },
      }}
    />
  );
};

export default CustomTextField;
